module.exports = __webpack_public_path__ + "logo_cf.0302f.png";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/logo/logo_cf.png
// module id = 4012
// module chunks = 0